import {sleep} from '@/utils/functions';
import {isMobileBrowser, isNative} from '@/utils/platform';

export const awaitScreenTransition = () =>
  sleep(isNative || isMobileBrowser ? 350 : 100);
